<template>
  <div id="aresvirus">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "aresvirus"
};
</script>

<style lang="less" scoped>
#aresvirus {
  overflow: hidden;
  position: relative;
  width: 100%;
  // min-width: 320px;
  // max-width: 750px;
  height: 100%;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/ares/App.vue